import { initialize, changeUser, getUser, openSession } from '@braze/web-sdk';
import { setProperties } from '@alltrails/analytics/amplitudeHelpers';
import { startBugsnag } from 'utils/bugsnag';
import '../../assets/javascripts/datadome';
import 'utils/Optimizely';
import './branch';

const data = global.__AT_DATA__;

if (data) {
  if (data.BRAZE_KEY) {
    initialize(data.BRAZE_KEY, { baseUrl: 'https://sdk.iad-03.braze.com' });

    if (data.store.user) {
      changeUser(String(data.store.user.id));
    }

    // now that we're opening up community to all, set true for everybody
    getUser()?.setCustomUserAttribute('is_community_beta_enabled', true);

    openSession();
  }

  if (data.store.user) {
    setProperties({ is_community_beta_enabled: true });
  }

  startBugsnag();

  global.branch.init(data.BRANCH_KEY, { metadata: data.branchMetadata });
}

// see https://github.com/aFarkas/lazysizes#user-content-js-api---options
window.lazySizesConfig = {
  expand: 10 // size buffer to start loading images before they reach viewport
};

// add simple support for background images:
document.addEventListener('lazybeforeunveil', e => {
  const target = e.target as HTMLElement;
  let bg = target.getAttribute('data-bg');
  if (bg) {
    if (bg.indexOf('url') < 0) {
      bg = `url('${bg}')`;
    }
    if (bg.slice(-1) == ')') {
      // if last character is ')' assume that we're just updated background image
      target.style.backgroundImage = bg;
    } else {
      // otherwise, update the entire background css
      target.style.background = bg;
    }
  }
});

import('lazysizes');
